import React from "react";
import H2 from "@material-tailwind/react/Heading2";
import LeadText from '@material-tailwind/react/LeadText';
import H5 from "@material-tailwind/react/Heading5";
import Helmet from "react-helmet";
import { Link } from 'react-router-dom';

function PreviousSCDS() {
    return (
      <div className="container max-w-8xl relative mx-auto">
        <Helmet>
          <title>The 7th International Conference on Soft Computing in Data Science 2022 (scds2023) - Previous SCDS</title>
        </Helmet>
        <nav aria-label="breadcrumb" style={{ padding: '0.5rem'}}>
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><Link to="/scds2023/home">Home</Link></li>
            <li class="breadcrumb-item "><Link to="/scds2023/">About</Link></li>
            <li class="breadcrumb-item active" aria-current="page">Previous SCDS</li>
          </ol>
        </nav>
          <div className="items-center flex flex-wrap">
              <div className="w-full lg:w-6/12 px-2 ml-auto mr-auto text-center">
                  <H2 color="dark">Previous SCDS</H2>
                  {/* <div className="text-dark-200">
                      <LeadText color="dark-200">
                      Institute for Big Data Analytics and Artificial Intelligence (IBDAAI)<br/>
                      Kompleks Al-Khawarizmi
                      Universiti Teknologi MARA (UiTM)
                      40450 Shah Alam, Selangor Darul Ehsan
                      Malaysia

                      <br/>E-mail: ibdaai@uitm.edu.my

                      <br/>Tel: +603-5543 5488
                      </LeadText>
                  </div> */}
              </div>
          </div>

  </div>
    );
}

export default PreviousSCDS;